import PropTypes from "prop-types";

const Partner = ({homepagedata}) => { 
    const FeaturesImage = ["One", "Two", "Three", "Four", "Five", "Six"]

    return (         

        <section className="PtnrSec" data-aos="fade-down-right" data-aos-easing="ease-in-sine" data-aos-duration="600" data-aos-delay="350">
            <div className="container">
                <div className="PtnrDv">
                    <div className='row PtnrRw CustRw'>
                    {Array.from({ length: 6 }, (_, index) => (
                        <div key={index} className='col-lg-4 col-md-6 CustPad'>

                            <div className='PtnrDts'>
                                <div className='PtnrDtsIg'>
                                  
                                             <img
                                                src={homepagedata?.[`features_image_${FeaturesImage[index]}`]}
                                                 width="28" height="28"
                                                alt={`Feature ${index + 1}`}
                                            
                                            /> 
                               


        
                                </div>
                                  <h5>  {homepagedata?.[`features_title_${FeaturesImage[index]}`]}</h5> 
                                <p> {homepagedata?.[`features_description_${FeaturesImage[index]}`]}</p>
                            </div>
                        </div>
                    ))}

                       
                    </div>
                </div>
            </div>
        </section>
    );
   
}
Partner.propTypes = {
    homepagedata: PropTypes.any
}

export default Partner;


